import loadable from "@loadable/component";
import LinearProgress from "@material-ui/core/LinearProgress";

/**
 * Dynamically loaded version of `DashboardPage`.
 */
const LoadablePage = loadable(
  () => import(/* webpackChunkName: "Dashboard" */ "."),
  {
    fallback: <LinearProgress />,
  }
);

export default LoadablePage;
